import { zodResolver } from '@hookform/resolvers/zod';
import { useMemo, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useNavigate } from 'react-router';
import { Form } from 'softcat:components/form.tsx';
import { WidgetService } from 'softcat:services/widget.ts';
import * as z from 'zod';

export const AppsCreate = () => {
    const intl = useIntl();
    const navigate = useNavigate();
    const [submitting, setSubmitting] = useState(false);
    const [onCreateError, setOnCreateError] = useState('');
    const appFileExtension = '.wgt';

    const CreateAppSchema = z.object({
        widget: z.instanceof(File, { message: intl.formatMessage({ id: 'APPS_CREATE_PAGE_FORM_WIDGET_VALIDATION_REQUIRED' }) }).refine(
            (file) => {
                return file.name.endsWith(appFileExtension);
            },
            { message: intl.formatMessage({ id: 'FORM_FILE_UPLOAD_VALIDATION_EXTENSION' }, { extensions: appFileExtension }) },
        ),
    });

    const onSubmit = async (values: z.infer<typeof CreateAppSchema>) => {
        setSubmitting(true);
        setOnCreateError('');

        try {
            const { id, version } = await WidgetService.create(values.widget);

            setSubmitting(false);

            return navigate(`/apps/edit/${id}/${version}`);
        } catch (error) {
            setSubmitting(false);
            setOnCreateError((error as Error).message);
        }
    };

    const defaultValues = useMemo(() => {
        return { widget: undefined };
    }, []);

    return (
        <Form<z.infer<typeof CreateAppSchema>> defaultValues={defaultValues} mode={'onBlur'} onSubmit={onSubmit} resolver={zodResolver(CreateAppSchema)}>
            <div className="space-y-3 px-4">
                <Form.Header
                    description={<FormattedMessage id={'APPS_CREATE_PAGE_DESCRIPTION'} />}
                    title={<FormattedMessage id={'APPS_CREATE_PAGE_HEADING'} />}
                />

                <Form.FileUpload accept={appFileExtension} label={<FormattedMessage id={'APPS_CREATE_PAGE_FORM_WIDGET_LABEL'} />} name={'widget'} />

                <Form.Footer
                    isSubmitting={submitting}
                    onCancel={() => {
                        return navigate('/apps');
                    }}
                    submitError={onCreateError && <FormattedMessage id={'APPS_CREATE_PAGE_FORM_SUBMIT_ERROR'} values={{ error: onCreateError }} />}
                    submitText={<FormattedMessage id={'BUTTON_CREATE'} />}
                />
            </div>
        </Form>
    );
};
